import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H7 } from 'foundations-components/transitional/components/H7';
import { Box } from 'foundations-components/transitional/components/Box';
import { Link } from 'foundations-components/transitional/components/Link';
// @ts-expect-error dependency missing types
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import LearnMoreModal from '../base/LearnMoreModal';
import { useModalTracker } from '../../../hooks/tracking';
import { ACADEMY_LESSON_SETUP_MEETING_URL, KNOWLEDGE_BASE_CREATE_MEETING_URL } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SetupPersonalMeetingLinkModal = ({
  onClose
}) => {
  const {
    trackLink
  } = useModalTracker('SetupPersonalMeetingLinkModal');
  return /*#__PURE__*/_jsxs(LearnMoreModal, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.setupPersonalMeetingLink.heading"
    }),
    illustrationName: "meetings",
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.setupPersonalMeetingLink.description"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.setupPersonalMeetingLink.p1"
      })
    }), /*#__PURE__*/_jsx(H7, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.setupPersonalMeetingLink.subHeading"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.setupPersonalMeetingLink.p2"
      })
    }), /*#__PURE__*/_jsx(KnowledgeBaseButton, {
      onClick: () => trackLink('create meeting article'),
      url: KNOWLEDGE_BASE_CREATE_MEETING_URL,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.readInstructions"
      })
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: ACADEMY_LESSON_SETUP_MEETING_URL,
      onClick: () => trackLink('setup meeting lesson'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.watchVideo"
      })
    })]
  });
};
SetupPersonalMeetingLinkModal.propTypes = {
  onClose: PropTypes.func
};
export default SetupPersonalMeetingLinkModal;